module.exports = __webpack_public_path__ + "img/square-silver-logo-small.3847e29d.png";